import { CheckCircle } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  Typography,
} from '@mui/material'
import React from 'react'

interface CompleteAppointmentDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  appointmentId?: string
  customerName?: string
}

export const CompleteAppointmentDialog: React.FC<CompleteAppointmentDialogProps> = ({
  open,
  onClose,
  onConfirm,
  appointmentId,
  customerName,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <CheckCircle color="success" />
          <Typography variant="h6">Complete Appointment</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to mark this appointment as completed?
        </DialogContentText>
        <Box mt={2}>
          <Typography variant="body2" color="text.secondary">
            <strong>Customer:</strong> {customerName || 'Unknown'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Appointment ID:</strong> {appointmentId || 'Unknown'}
          </Typography>
        </Box>
        <Box mt={2} p={2} bgcolor="success.light" borderRadius={1}>
          <Typography variant="body2" color="success.dark">
            <strong>Note:</strong> This action will mark the appointment as completed. This
            typically means the scout has finished the on-site visit and collected all necessary
            data.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="success" variant="contained">
          Mark as Complete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
